<template>
    <div :id="id" class="profile-segment">
        <div class="profile-segment__container">
            <div class="profile-segment__image">
                <div v-if="segmentData.image" class="profile-segment__image-container" :style="`background-image: url('${url}')`"></div>
            </div>
            <div v-if="segmentData.name" class="profile-segment__titles">
                <h2 v-if="segmentData.name" class="profile-segment__name text-heading">{{ segmentData.name }}</h2>
                <p v-if="segmentData.title" class="profile-segment__title text-heading">{{ segmentData.title }}</p>
            </div>
            <div class="profile-segment__copy">
                <Markdown :markdown="segmentData.content" />
            </div>
        </div>
    </div>
</template>

<script>
import { bucketImage } from "~/utils";
import Markdown from "~/components/handbook/Markdown";

export default {
    components: {
        Markdown,
    },

    props: {
        id: String,
        segmentData: Object,
    },

    computed: {
        url: function () {
            return bucketImage(this.segmentData.image);
        },
    },
};
</script>
